import getCustomerSegment from "../javascript/utils/getCustomerSegment";
import { hasActiveSession } from "../javascript/utils/cookie";

export const getAnalyticsV2Proxy = () => {
  window.maxAnalyticsEventsV2 = window.maxAnalyticsEventsV2 || [];
  return window.maxAnalyticsEventsV2;
};

export const getAnalyticsProxy = () => {
  window.maxAnalyticsEvents = window.maxAnalyticsEvents || [];
  return window.maxAnalyticsEvents;
};

export const getAnalyticsPublicProxy = () => {
  window.maxAnalyticsPublicEvents = window.maxAnalyticsPublicEvents || [];
  return window.maxAnalyticsPublicEvents;
};

export const createAnalyticsEvent = (eventName, eventData) => {
  return new CustomEvent("maxAnalyticsEvent", {
    detail: {
      eventName,
      page: window.location.pathname,
      eventData,
    },
  });
};

export const getSiteVersion = (customerSegment) => {
  switch (customerSegment) {
    case "Retail":
    case "Anonymous":
      return "Retail";
    default:
      return "Trade";
  }
};

export const submitV2AnalyticsEvent = (eventName, eventData) => {
  const customerSegment = getCustomerSegment();
  const searchId =
    window.sessionStorage && window.sessionStorage.getItem("searchId");
  const enrichedEventData = {
    ...eventData,
    loggedInStatus: customerSegment,
    siteVersion: getSiteVersion(customerSegment),
    searchId,
  };
  const analyticsEvent = createAnalyticsEvent(eventName, enrichedEventData);
  if (hasActiveSession()) {
    getAnalyticsV2Proxy().push(analyticsEvent);
  } else {
    getAnalyticsPublicProxy().push(analyticsEvent);
  }
};
